import { gql } from "apollo-angular";

const GET_CATEGORIZATION_SCHEMES= gql`
    query getCategorizationSchemes($organizationId: Long!){
    categorizationSchemes (
        organizationId: $organizationId
    ) {
        id,
        name,type
      }
    }
`;

export default GET_CATEGORIZATION_SCHEMES;